import React from 'react'
import { css } from '@emotion/css'
import { LoadingTextMask } from '../../legacy-design-system/loading-masks'
import { CellRenderer } from '../../legacy-design-system/grid'
import { Application } from './shared'
import { ApplicationAttackStatus } from '../application-attack-status'

export function getAttackStatusCellRenderer(): CellRenderer<Application> {
  return function attackStatusCellRenderer({
    rowData: { attackStatus, attackTotal, hasAProtectedServer },
    getCellContentProps
  }) {
    return (
      <div {...getCellContentProps({})}>
        <ApplicationAttackStatus
          hasAProtectedServer={hasAProtectedServer}
          attackStatus={attackStatus}
          attackTotal={attackTotal}
        />
      </div>
    )
  }
}

const loadingCss = css`
  width: 100%;
  display: flex;
  justify-content: center;
`

export function loadingAttackStatusCellRenderer() {
  return (
    <div className={loadingCss}>
      <LoadingTextMask min={3} max={4} />
    </div>
  )
}
